<template>
  <div
    :class="['Gongview_pag',isList?'isList':null]"
    style="margin:0 auto;"
  >
    <div class="tc-30"></div>
    <div class="block">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="param.page"
        :page-size="param.limit"
        layout="prev, pager, next, jumper"
        :total="param.total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  components: {},
  data () {
    return {}
  },
  props: {
    isList: {
      type: Boolean,
      required: false,
      default: false
    },
    param: {
      type: Object,
      required: true
    },
    loadingTrue: {
      type: Boolean,
      required: true
    }
  },
  computed: {},
  methods: {
    handleCurrentChange (val) {
      // 分页点击事件
      this.param.page = val
      this.$emit('change')
    }
  },
  watch: {},
  created () {},
  mounted () {}
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.Gongview_pag {
  text-align: center;
  .tc-30 {
    width: 100%;
    height: 20px;
  }
    .tc-27 {
    width: 100%;
    height: 27px;
  }
}
.isList {
  background: #f5f5f5;
}
/deep/.el-pager li.active{
  color: #b79255;
}
</style>
